import React from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

import AdminContentPart from './AdminContentPart';
import AdminHeader from './AdminHeader';
import AdminMainPart from './AdminMainPart';
import AdminSidebar from './AdminSidebar';

const AdminLayout = () => {
  /* ui slice = drawer, GeneralSetting slice = company info */
  const adminSideDrawer = useSelector(state => state.ui.adminSideDrawer);
  const generalSetting  = useSelector(state => state.GeneralSetting.generalSetting);

  return (
    <AdminMainPart adminSideDrawer={adminSideDrawer}>
      <AdminHeader
        title={generalSetting?.company_name}
        faviconIcon={generalSetting?.fav_icon}
      />

      {/* sidebar only when open */}
      {adminSideDrawer && <AdminSidebar />}

      <AdminContentPart>
        <Outlet />
      </AdminContentPart>
    </AdminMainPart>
  );
};

export default AdminLayout;
